import React from 'react'
import { Grid, Typography, Chip } from '@the-platform-group/component-library'
import { usePeopleMergeContext } from 'pages/MergeProfiles/contexts/PeopleMergeContext'
import { getProfileFieldValue } from 'pages/MergeProfiles/utils'
import { PEOPLE_MERGE_PREVIEW_FIELDS } from 'pages/MergeProfiles/constants'
import ProfileComparisonTable from '../../ProfileComparisonTable'
import { StyledCell } from '../../ComparisonRow'

const MergedProfilePreview = () => {
  const { reviewMutation } = usePeopleMergeContext()
  const { data: reviewData } = reviewMutation

  const primaryJobChanged = reviewData?.meta?.review?.primaryJobChanged

  if (!reviewData?.data) {
    return null
  }

  const renderFieldValue = field => {
    const value = getProfileFieldValue({
      person: reviewData.data,
      preview: reviewData,
      fieldKey: field.key,
      isSource: false,
      fromReview: true,
    })

    // Special rendering for jobFunction (show primary job changed chip)
    if (field.key === 'jobFunction') {
      return (
        <StyledCell item xs={8} sx={{ p: 1.5 }}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <Typography variant="body2">{value}</Typography>
            </Grid>
            {primaryJobChanged && (
              <Grid item>
                <Chip
                  label="Updated primary job"
                  variant="outlined"
                  color="primary"
                  size="x-small"
                />
              </Grid>
            )}
          </Grid>
        </StyledCell>
      )
    }

    // Default rendering
    return (
      <StyledCell item xs={8} sx={{ p: 1.5 }}>
        <Typography variant="body2">{value}</Typography>
      </StyledCell>
    )
  }

  return (
    <ProfileComparisonTable
      fields={PEOPLE_MERGE_PREVIEW_FIELDS}
      renderFieldValue={renderFieldValue}
      headers={['Merged profile preview', '']}
      columnWidths={[4, 8]}
    />
  )
}

export default MergedProfilePreview
